import { useState } from "react";
import { Box, Button, Chip, CircularProgress } from "@mui/material";
import { useRecordContext } from "react-admin";
import { OneMealService } from "../../services/OneMealService";
import CommonListTable, { CommonListColumn } from "../Common/CommonListTable";
import EventBus from "../../EventBus";
import { EventBusEventsEnum } from "../../enums/EventBusEventsEnum";
import { CustomSnackbarTypes } from "../Common/CustomSnackBar";
import { PaymentLinkDailog } from "../Common/PaymentLinksDailogs";

const oneMealService = new OneMealService();

const OneMealTimeExtensionTab = () => {
  const record = useRecordContext();
  const [paymentLinks, setPaymentLinks] = useState<string[]>([]);
  const [paymentDialog, setPaymentDialog] = useState(false);
  const [sendingId, setSendingId] = useState<number | null>(null);

  const extensions: any[] = Array.isArray(record?.timeExtensions) ? record.timeExtensions : [];

  const handleSendPaymentLink = async (extensionId: number) => {
    setSendingId(extensionId);
    try {
      const links = await oneMealService.sendTimeExtensionPaymentLink(extensionId);
      const linkArr = Array.isArray(links) ? links : [links];
      setPaymentLinks(linkArr);
      setPaymentDialog(true);
    } catch {
      EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
        message: "Failed to send payment link",
        type: CustomSnackbarTypes.ERROR,
      });
    } finally {
      setSendingId(null);
    }
  };

  const columns: CommonListColumn[] = [
    { label: "ID", field: "id" },
    { label: "Extend By", render: (row) => `${row?.extendBy} hr` },
    { label: "Prev Slot Size", render: (row) => `${row?.previousSlotSize} hr` },
    { label: "New Slot Size", render: (row) => row?.newSlotSize ? `${row.newSlotSize} hr` : "-" },
    { label: "Gross Amount", render: (row) => `₹${row?.grossAmount ?? 0}` },
    { label: "Final Amount", render: (row) => `₹${row?.amount ?? 0}` },
    { label: "Wallet Used", render: (row) => `₹${row?.walletBalanceUsed ?? 0}` },
    { label: "Status", field: "status", type: "status" },
    { label: "Created At", field: "createdAt", type: "datetime" },
    {
      label: "Action",
      stopRowClick: true,
      render: (row) =>
        row?.status === "NOT_PAID" ? (
          <Button
            size="small"
            variant="contained"
            color="primary"
            disabled={sendingId === row?.id}
            onClick={() => handleSendPaymentLink(row.id)}
          >
            {sendingId === row?.id ? (
              <CircularProgress size={16} color="inherit" />
            ) : (
              "Send Payment Link"
            )}
          </Button>
        ) : (
          <Chip size="small" label={row?.status} color="success" />
        ),
    },
  ];

  return (
    <Box>
      <CommonListTable
        title="Time Extensions"
        columns={columns}
        data={extensions}
        loading={false}
        emptyText="No time extensions found for this visit"
      />
      {paymentDialog && (
        <PaymentLinkDailog
          data={paymentLinks}
          open={paymentDialog}
          callback={() => setPaymentDialog(false)}
        />
      )}
    </Box>
  );
};

export default OneMealTimeExtensionTab;
